import styled, { CSSProperties } from "styled-components";
import { appColors } from "./colors";

const Light = styled.p<{ padding?: number; color?: string; cursor?: string; fontSize?: number; lineHeight?: number }>`
  display: flex;
  padding: ${({ padding }) => padding}px;
  margin: 0;
  color: ${({ color = appColors.textColor }) => color};
  font-family: Poppins;
  font-style: normal;
  cursor: ${({ cursor = "auto" }) => cursor};
  font-weight: 200;
  font-size: ${({ fontSize }) => fontSize}px;
  line-height: ${({ lineHeight }) => lineHeight}px;
`;

const Regular = styled.p<{ padding?: number; color?: string; fontSize?: number; lineHeight?: number }>`
  display: flex;
  padding: ${({ padding }) => padding}px;
  margin: 0;
  color: ${({ color = appColors.textColor }) => color};
  font-family: Poppins;
  font-style: normal;
  font-weight: 400;
  font-size: ${({ fontSize }) => fontSize}px;
  line-height: ${({ lineHeight }) => lineHeight}px;
`;

const Medium = styled.p<{ padding?: number; color?: string; fontSize?: number; lineHeight?: number }>`
  display: flex;
  padding: ${({ padding }) => padding}px;
  margin: 0;
  color: ${appColors.textColor};
  font-family: Poppins;
  font-style: normal;
  font-weight: 500;
  font-size: ${({ fontSize }) => fontSize}px;
  line-height: ${({ lineHeight }) => lineHeight}px;
`;
interface LightFontProps {
  fontSize?: number;
  children: React.ReactNode;
  color?: string;
  lineHeight?: number;
  padding?: number;
  pointer?: boolean;
}

const LightFont: React.FC<LightFontProps> = ({
  fontSize = 16,
  children,
  color = appColors.textColor,
  lineHeight = 30,
  padding = 0,
  pointer = false,
}) => {
  return (
    <Light
      cursor={pointer ? "pointer" : "auto"}
      fontSize={fontSize}
      lineHeight={lineHeight}
      padding={padding}
    >
      {children}
    </Light>
  );
};

interface RegularFontProps {
  fontSize?: number;
  children: React.ReactNode;
  lineHeight?: number;
  padding?: number;
  color?: string;
}

const RegularFont: React.FC<RegularFontProps> = ({
  fontSize = 16,
  children,
  lineHeight = 30,
  padding = 0,
  color = appColors.textColor,
}) => {
  return (
    <Regular
      fontSize={fontSize}
      lineHeight={lineHeight}
      color={color}
      padding={padding}
    >
      {children}
    </Regular>
  );
};

interface MediumFontProps {
  fontSize?: number;
  children: React.ReactNode;
  lineHeight?: number;
  color?: string;
  padding?: number;
}

const MediumFont: React.FC<MediumFontProps> = ({
  fontSize = 16,
  children,
  lineHeight = 30,
  color = appColors.textColor,
  padding = 0,
}) => {
  return (
    <Medium
      fontSize={fontSize}
      lineHeight={lineHeight}
      color={color}
      padding={padding}
    >
      {children}
    </Medium>
  );
};
export default { Light, Regular, Medium, LightFont, RegularFont, MediumFont };